import { render, staticRenderFns } from "./Domicilio.vue?vue&type=template&id=42c7de84"
import script from "./Domicilio.vue?vue&type=script&lang=js"
export * from "./Domicilio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c7de84')) {
      api.createRecord('42c7de84', component.options)
    } else {
      api.reload('42c7de84', component.options)
    }
    module.hot.accept("./Domicilio.vue?vue&type=template&id=42c7de84", function () {
      api.rerender('42c7de84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Domicilio.vue"
export default component.exports